export enum FormAction {
  INPUT,
  REMOVE
}

export enum FormField {
  CAUTELAR = 'cautelar',
  CODIGO_COLEGIADO = 'codigoColegiado',
  COLEGIO = 'colegio',
  COMUNIDAD_AUTONOMA = 'comunidadAutonoma',
  DATOS_CAUSA_CON_DETENIDO = 'datosCausaConDetenido',
  DATOS_CAUSA_CON_PRESO = 'datosCausaConPreso',
  DATOS_CAUTELARISIMA = 'datosCautelarisima',
  DATOS_CUANTIA_COMISION_IMPAGO_RECIBOS = 'datosCuantiaComisionImpagoRecibos',
  DATOS_CUANTIA_COSTAS = 'datosCuantiaCostas',
  DATOS_CUANTIA_INTERESES = 'datosCuantiaIntereses',
  DATOS_CUANTIA_INTERESES_DEMORA = 'datosCuantiaInteresesDemora',
  DATOS_CUANTIA_INTERESES_REMUNERATORIOS = 'datosCuantiaInteresesRemuneratorios',
  DATOS_CUANTIA_PENALIZACION_RETRASO_PAGO = 'datosCuantiaPenalizacionRetrasoPago',
  DATOS_CUANTIA_PRINCIPAL = 'datosCuantiaPrincipal',
  DATOS_CUANTIA_RECONVENCION = 'datosCuantiaReconvencion',
  DATOS_DELITO = 'datosDelito',
  DATOS_DEUDA_PARTIDO_JUDICIAL = 'datosDeudaPartidoJudicial',
  DATOS_FECHA = 'datosFecha',
  DATOS_FECHA_ACUERDO = 'datosFechaAcuerdo',
  DATOS_FUNDAMENTOS_DERECHO = 'datosFundamentosDerecho',
  DATOS_HORA = 'datosHora',
  DATOS_LOCALIDAD = 'datosLocalidad',
  DATOS_MASC = 'datosMasc',
  DATOS_MATERIA = 'datosMateria',
  DATOS_MERCANTIL = 'datosMercantil',
  DATOS_MEDIDA_CAUTELAR_COETANEA = 'datosMedidaCautelarCoetanea',
  DATOS_MEDIDA_CAUTELAR_PREVIA = 'datosMedidaCautelarPrevia',
  DATOS_NUMERO_EXPEDIENTE_ORIGEN = 'datosNumeroExpedienteOrigen',
  DATOS_OBJETO_RECURSO = 'datosObjetoRecurso',
  DATOS_OBSERVACIONES = 'datosObservaciones',
  DATOS_ORGANISMO = 'datosOrganismo',
  DATOS_ORGANISMO_ORIGEN = 'datosOrganismoOrigen',
  DATOS_ORIGEN_DEUDA = 'datosOrigenDeuda',
  DATOS_PETICION = 'datosPeticion',
  DATOS_PETICION_COMPLEMENTARIA = 'datosPeticionComplementaria',
  DATOS_RECLAMACION_COMUNIDAD = 'datosReclamacionComunidad',
  DATOS_RECLAMACION_CONSUMIDOR = 'datosReclamacionConsumidor',
  DATOS_RECONVENCION = 'datosReconvencion',
  DATOS_TIPO_CUANTIA = 'datosTipoCuantia',
  DATOS_URGENTE = 'datosUrgente',
  DATOS_VIOLENCIA_GENERO = 'datosViolenciaGenero',
  DATOS_YEAR_EXPEDIENTE_ORIGEN = 'datosYearExpedienteOrigen',
  DESTINY_COLLEGE_BODY = 'destinyCollegeBody',
  DESTINY_COLLEGE_BODY_ORDER = 'destinyCollegeBodyOrder',
  DOCUMENTOS_ANEXOS = 'documentosAnexos',
  DOCUMENTOS_ANEXOS_ARCHIVO = 'documentosAnexosArchivo',
  DOCUMENTO_PRINCIPAL = 'documentoPrincipal',
  DOCUMENTO_PRINCIPAL_ARCHIVO = 'documentoPrincipalArchivo',

  // MODAL DOCUMENT
  DOCUMENTO_PRINCIPAL_FORM_ARCHIVO = 'documentoPrincipalFormArchivo',
  DOCUMENTO_PRINCIPAL_FORM_SUBTIPO = 'documentoPrincipalFormSubtipo',
  DOCUMENTO_PRINCIPAL_FORM_DESCRIPCION = 'documentoPrincipalFormDescripcion',
  DOCUMENTO_PRINCIPAL_FORM_SIGIN = 'documentoPrincipalFormSignin',

  ENTIDAD = 'entidad',
  ENTIDAD_CODIGO = 'codigo',
  ENTIDAD_NOMBRE = 'nombre',
  ES_CORRECCION = 'esCorreccion',
  EXCESO_CABIDA = 'excesoCabida',
  FECHA_RESOLUCION = 'fechaResolucion',
  ID = 'id',
  ID_MENSAJE_CORRECCION = 'idMensajeCorreccion',
  INTERVINIENTES = 'intervinientes',
  INTERVINIENTES_FROM_LEXON_VALIDATED = 'intervinientesFromLexonValidated',
  INTERVINIENTES_INTERVENCION_TIPO = 'intervencionTipo',
  INTERVINIENTE_ADD_PROFESIONAL_REPRESENTANTE_PROCESAL = 'profesionalRepresentanteProcesal',
  INTERVINIENTE_CUENTA_BANCARIA_TITULAR = 'cuentaBancariaTitular',
  INTERVINIENTE_CUENTA_BANCARIA_NIF = 'cuentaBancariaNIF',
  INTERVINIENTE_CUENTA_BANCARIA_NUMERO_CUENTA = 'cuentaBancariaNumeroCuenta',
  INTERVINIENTE_CUENTA_BANCARIA_TIPO = 'cuentaBancariaTipo',
  INTERVINIENTE_DIRECCION = 'direccion',
  INTERVINIENTE_DIRECCION_BLOQUE = 'direccion.bloque',
  INTERVINIENTE_DIRECCION_CIUDAD_LOCALIDAD = 'direccion.ciudadLocalidad',
  INTERVINIENTE_DIRECCION_COD_POSTAL = 'direccion.codigoPostal',
  INTERVINIENTE_DIRECCION_ESCALERA = 'direccion.escalera',
  INTERVINIENTE_DIRECCION_INFORMACION_COMPLEMENTARIA = 'direccion.informacionComplementaria',
  INTERVINIENTE_DIRECCION_LETRA = 'direccion.letra',
  INTERVINIENTE_DIRECCION_MUNICIPIO = 'direccion.municipio',
  INTERVINIENTE_DIRECCION_NOMBRE_VIA = 'direccion.nombreVia',
  INTERVINIENTE_DIRECCION_NUMERO = 'direccion.numero',
  INTERVINIENTE_DIRECCION_PAIS = 'direccion.pais',
  INTERVINIENTE_DIRECCION_PISO = 'direccion.piso',
  INTERVINIENTE_DIRECCION_PROVINCIA = 'direccion.provincia',
  INTERVINIENTE_DIRECCION_KM = 'direccion.km',
  INTERVINIENTE_DIRECCION_SN = 'direccion.sinNumero',
  INTERVINIENTE_DIRECCION_TIPO_VIA = 'direccion.tipoVia',
  INTERVINIENTE_EMAIL = 'email',
  INTERVINIENTE_FECHA_NACIMIENTO = 'fechaNacimiento',
  INTERVINIENTE_IDENTIFICACION = 'identificacion',
  INTERVINIENTE_IDENTIFICACION_TIPO = 'identificacionTipo',
  INTERVINIENTE_INFORMAR_FISCALIA = 'informarFiscalia',
  INTERVINIENTE_INTERVENCION_TIPO = 'intervencionTipo',
  INTERVINIENTE_LUGAR_NACIMIENTO = 'lugarNacimiento',
  INTERVINIENTE_NACIONALIDAD = 'nacionalidad',
  INTERVINIENTE_NO_INTERVIENE_OTRO_PROFESIONAL = 'noIntervieneOtroProfesional',
  INTERVINIENTE_NOMBRE = 'nombre',
  INTERVINIENTE_NOMBRE_MADRE = 'nombreMadre',
  INTERVINIENTE_NOMBRE_PADRE = 'nombrePadre',
  INTERVINIENTE_PAIS_NACIMIENTO = 'paisNacimiento',
  INTERVINIENTE_PERSONA_TIPO = 'personaTipo',
  INTERVINIENTE_PRIMER_APELLIDO = 'primerApellido',
  INTERVINIENTE_RAZON_SOCIAL = 'razonSocial',
  INTERVINIENTE_REPRESENTACION_TIPO = 'representacionTipo',
  INTERVINIENTE_REPRESENTANTES_LEGALES = 'representantesLegales',
  INTERVINIENTE_REPRESENTANTES_PROCESALES = 'representantesProcesales',
  INTERVINIENTE_REPRESENTANTE_LEGAL = 'representanteLegal',
  INTERVINIENTE_REPRESENTANTE_PROCESAL = 'representanteProcesal',
  INTERVINIENTE_REPRESENTANTE_PROCESAL_EMAIL = 'email',
  INTERVINIENTE_REPRESENTANTE_PROCESAL_NIF = 'nif',
  INTERVINIENTE_SEGUNDO_APELLIDO = 'segundoApellido',
  INTERVINIENTE_SEXO = 'sexo',
  INTERVINIENTE_TELEFONO = 'telefono',
  INTERVINIENTE_TIPO_IDENTIFICACION = 'identificacionTipo',
  INTERVINIENTE_TIPO_INTERVENCION = 'intervencionTipo',
  INTERVINIENTE_TIPO_PERSONA = 'personaTipo',
  MUNICIPIO = 'municipio',
  NIG = 'nig',
  NIG_1 = 'nig1',
  NIG_2 = 'nig2',
  NIG_3 = 'nig3',
  NIG_4 = 'nig4',
  NIG_5 = 'nig5',
  NIG_FORM_EXPEDIENTE = 'nigFormExpediente',
  NIG_FULL_NUMBER = 'nigFullNumber',
  NUMERO_RESOLUCION = 'numeroResolucion',
  ORGANO_DESTINO = 'organoDestino',
  ORGANO_DESTINO_COMUNIDAD_AUTONOMA = 'organoDestinoComunidadAutonoma',
  ORGANO_DESTINO_DESCRIPCION = 'organoDestinoDescripcion',
  ORGANO_DESTINO_ENVIAR_JUZGADO_GUARDIA = 'organoDestinoEnviarAJuzgado',
  ORGANO_DESTINO_DE_TITULO_JUDICIAL = 'organoDestinoDeTituloJudicial',
  ORGANO_DESTINO_ORDEN_DESCRIPCION = 'organoDestinoOrdenDescripcion',
  ORGANO_DESTINO_ORDEN_JUDICIAL = 'organoDestinoOrdenJudicial',
  ORGANO_DESTINO_ORGANO_JUDICIAL = 'organoDestinoOrganoJudicial',
  ORGANO_DESTINO_ORGANO_JUDICIAL_FORM = 'organoDestino.organoDestinoOrganoJudicial',
  ORGANO_DESTINO_PARTIDO_JUDICIAL = 'organoDestinoPartidoJudicial',
  ORGANO_DESTINO_PROVINCIA = 'organoDestinoProvincia',
  ORGANO_ORIGEN = 'organoOrigen',
  ORGANO_ORIGEN_COMUNIDAD_AUTONOMA = 'organoOrigenComunidadAutonoma',
  ORGANO_ORIGEN_DESCRIPCION = 'organoOrigenDescripcion',
  ORGANO_ORIGEN_ENVIAR_JUZGADO_GUARDIA = 'organoOrigenEnviaAJuzgado',
  ORGANO_ORIGEN_ORDEN_DESCRIPCION = 'organoOrigenOrdenDescripcion',
  ORGANO_ORIGEN_ORDEN_JUDICIAL = 'organoOrigenOrdenJudicial',
  ORGANO_ORIGEN_ORGANO_JUDICIAL = 'organoOrigenOrganoJudicial',
  ORGANO_ORIGEN_PARTIDO_JUDICIAL = 'organoOrigenPartidoJudicial',
  ORGANO_ORIGEN_PROVINCIA = 'organoOrigenProvincia',
  ORGANO_ORIGEN_TIPO_ORIGEN = 'organoOrigenTipoOrigen',
  ORGANO_ORIGEN_ORGANISMO_ORIGEN = 'organoOrigenOrganismoOrigen',
  ORGANO_ORIGEN_NUMERO_EXPEDIENTE = 'organoOrigenNumeroExpediente',
  ORGANO_ORIGEN_YEAR_EXPEDIENTE = 'organoOrigenYearExpediente',
  PROCEDIMIENTO = 'procedimiento',
  PROCEDIMIENTO_DESCRIPCION = 'procedimientoDescripcion',
  PROCEDIMIENTO_NUMERO_FORM = 'procedimientoNumeroForm',
  PROCEDIMIENTO_NUMERO_ORIGEN_FORM = 'procedimientoNumeroOrigenForm',
  PROCEDIMIENTO_NUMERO_PIEZA = 'procedimientoNumeroPieza',
  PROCEDIMIENTO_NUMERO_PIEZA_FORM = 'procedimientoNumeroPiezaForm',
  PROCEDIMIENTO_ORIGEN = 'procedimientoOrigen',
  PROCEDIMIENTO_ORIGEN_REFERENCIA = 'procedimientoOrigenReferencia',
  PROCEDIMIENTO_REFERENCIA = 'procedimientoReferencia',
  PROCEDIMIENTO_TIPOLOGIA_FORM = 'procedimientoTipologiaForm',
  PROCEDIMIENTO_TIPO_FORM = 'procedimientoTipoForm',
  PROCEDIMIENTO_TIPO_ORIGEN_FORM = 'procedimientoTipoOrigenForm',
  PROCEDIMIENTO_YEAR_FORM = 'procedimientoYearForm',
  PROCEDIMIENTO_YEAR_ORIGEN_FORM = 'procedimientoYearOrigenForm',
  PROVINCIA = 'provincia',
  REMITENTE_TITULAR = 'titular',
  RESOLUCION = 'resolucion',
  RESOLUCION_BIS = 'resolucionBis',
  SENDER = 'sender',
  TIPO = 'tipo',
  TIPO_ESCRITO = 'tipoEscrito',
  TIPO_RESOLUCION = 'tipoResolucion',
  TRASLADO_COPIA = 'trasladoCopia',
  TRASLADO_COPIAS = 'trasladoCopias',
  TRASLADO_COPIAS_COLEGIADO_NOMBRE = 'colegiadoNombreTrasladoCopias',
  TRASLADO_COPIAS_COLEGIADO_NUMERO = 'colegiadoNumeroTrasladoCopias',
  TRASLADO_COPIAS_COLEGIO = 'colegioTrasladoCopias',
  TRASLADO_COPIAS_COMUNIDAD = 'comunidadTrasladoCopias',
  TRASLADO_COPIAS_PROVINCIA = 'provinciaTrasladoCopias',
  TRASLADO_COPIAS_TIPO = 'tipoTraslado',
  YEAR_RESOLUCION = 'yearResolucion'
}
